import { Axios } from '@config/axios';
import { apiEndpoints } from '@constants/apiEndpoints';
import {
  ApiConsumer,
  ApiConsumerService,
  CreateApiConsumerRequest,
  CreateApiConsumerResponse,
} from '@models/ApiConsumer';

export const API_CONSUMER_MANAGE_PERMISSION = 'api_consumers.manage';

export const API_CONSUMER_SERVICES: Record<
  ApiConsumerService,
  { label: string; description: string; sensitive?: boolean }
> = {
  'projects.read': {
    label: 'Obras e empreendimentos',
    description: 'Consulta obras, unidades, empreendimentos e progresso.',
  },
  'budgets.read': {
    label: 'Orçamentos',
    description: 'Consulta orçamentos, itens, composições e planejamento.',
  },
  'purchase_orders.read': {
    label: 'Pedidos e ordens',
    description: 'Consulta pedidos e ordens de compra.',
  },
  'suppliers.read': {
    label: 'Fornecedores',
    description: 'Consulta fornecedores vinculados à conta.',
    sensitive: true,
  },
  'payroll.read': {
    label: 'Folha de pagamento',
    description: 'Consulta colaboradores e lançamentos de folha.',
    sensitive: true,
  },
  'financials.read': {
    label: 'Financeiro',
    description: 'Consulta pagamentos, contas e transferências.',
    sensitive: true,
  },
};

export const ALL_API_CONSUMER_SERVICES = Object.keys(API_CONSUMER_SERVICES) as ApiConsumerService[];

export function canManageApiConsumers(user: { roles?: string[]; permissions?: string[] }) {
  return (user.roles || []).some((role) => ['master', 'admin'].includes(role)) ||
    (user.permissions || []).includes(API_CONSUMER_MANAGE_PERMISSION);
}

export async function getApiConsumers() {
  const response = await Axios.get<ApiConsumer[]>(apiEndpoints.API_CONSUMERS.BASE);
  return response.data;
}

export async function createApiConsumer(data: CreateApiConsumerRequest) {
  const response = await Axios.post<CreateApiConsumerResponse>(apiEndpoints.API_CONSUMERS.BASE, data);
  return response.data;
}

export async function revokeApiConsumer(id: string) {
  await Axios.delete(`${apiEndpoints.API_CONSUMERS.BASE}/${encodeURIComponent(id)}`);
}
